module.exports = __webpack_public_path__ + "static/media/mail-icon-blue.f62cbbe4.svg";